import React from 'react';
import {View, Text, StyleSheet} from 'react-native';
import {useSelector} from 'react-redux';
import {
  getLocationDisplay,
  getPlaceQuantity,
  getProductRemainingCount
} from './utils/scanProgressUtils';
import { getCurrentTote, filterTotesWithPendingItems } from './utils/scanningUtils';

const LocationHeader = ({windowWidth}) => {
  const nextPickItem = useSelector(state => state.scanToCart.nextPickItem);
  const toteAssignments = useSelector(
    state => state.scanToCart.toteAssignments
  );
  const isCartView = useSelector(state => state.scanToCart.isCartView);
  const previousNextPickItems = useSelector(
    state => state.scanToCart.previousNextPickItems
  );

  const currentItem = nextPickItem?.item || null;
  const currentTote = getCurrentTote(previousNextPickItems, toteAssignments, nextPickItem);

  const locationDisplay = getLocationDisplay(currentItem);
  const scanUpTo = getProductRemainingCount(
    currentItem?.product_id,
    toteAssignments
  );
  const placeQty = getPlaceQuantity(currentTote);
  const fontSize = windowWidth > 900 ? isCartView && placeQty > 1 ? 50: 30 : isCartView && placeQty > 1 ? 40 : 25
  const hasPendingItems = previousNextPickItems.length > 0 || (toteAssignments && filterTotesWithPendingItems(toteAssignments).length > 0);
  const displayHeader = isCartView ? (hasPendingItems && placeQty > 0) : true

  return (
    <View style={[styles.container, windowWidth <= 900 && styles.containerMobile,{display: displayHeader ? 'flex' : 'none'}]}>
      <View style={styles.section}>
        <Text style={[styles.label, windowWidth <= 900 && styles.labelMobile]}>
          {isCartView ? 'Scan Tote:' : 'Location:'}
        </Text>
        <Text style={[styles.value, windowWidth <= 900 && styles.valueMobile,{fontSize: fontSize }]}>
          {isCartView ? currentTote?.tote_id || 'No Tote' : locationDisplay}
        </Text>
      </View>
      <View style={styles.section}>
        <Text style={[styles.label, windowWidth <= 900 && styles.labelMobile]}>
          {isCartView ? 'Place' : 'Scan up to'}
        </Text>
        <Text style={[styles.value, {fontSize: fontSize}]}>
          {isCartView
            ? `${placeQty} item${placeQty !== 1 ? 's' : ''}`
            : scanUpTo}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 12,
    paddingVertical: 6
  },
  containerMobile: {
    paddingHorizontal: 6,
    paddingVertical: 4
  },
  section: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  label: {
    color: '#4ade80',
    fontSize: 16,
    marginRight: 8,
    fontFamily: 'Poppins_300Light'
  },
  labelMobile: {
    fontSize: 14,
    marginRight: 6
  },
  value: {
    color: '#4ade80',
    fontSize: 30,
    fontFamily: 'Poppins_600SemiBold',
    letterSpacing: 1
  },
  valueMobile: {
    fontSize: 22,
    letterSpacing: 0.5
  }
});

export default LocationHeader;
